import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import Layout from "@/components/Layout";
import API from "@/lib/api";
import { MessageSquare } from "lucide-react";

export default function Messages() {
  const navigate = useNavigate();
  const [items, setItems] = useState(null);
  useEffect(() => { API.get("/conversations").then((r) => setItems(r.data)).catch(() => setItems([])); }, []);

  return (
    <Layout>
      <h1 className="font-serif text-2xl font-bold text-[#0F1230] mb-4">Messaggi</h1>
      {items === null ? <p className="text-[#4A4E68]">Caricamento...</p> : items.length === 0 ? (
        <p className="text-[#4A4E68]">Nessuna conversazione ancora.</p>
      ) : (
        <div className="space-y-2">
          {items.map((c) => (
            <button key={c.id} data-testid={`conversation-${c.id}`} onClick={() => navigate(`/messages/${c.id}`)} className="text-left w-full bg-white rounded-[18px] border border-[#DADFEA] p-4 flex gap-3 items-center hover:shadow-md transition-shadow">
              <div className="w-10 h-10 rounded-full bg-[#1F4FE0] text-white flex items-center justify-center font-semibold">{(c.other_name || "?")[0]}</div>
              <div className="min-w-0 flex-1">
                <div className="flex items-center gap-2">
                  <span className="font-semibold text-[#0F1230] truncate">{c.other_name}</span>
                  {c.contact_shared && <span className="text-[10px] bg-[#E8F5E9] text-[#2E7D32] px-1.5 rounded-full">Contatti</span>}
                </div>
                <p className="text-sm text-[#4A4E68] truncate">{c.request_title}</p>
                <p className="text-sm text-[#2A2E48] truncate">{c.last_message}</p>
              </div>
            </button>
          ))}
        </div>
      )}
    </Layout>
  );
}
